import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import { BsHouse, BsShopWindow } from "react-icons/bs";
import { PiBed } from "react-icons/pi";
import { useStateContext } from "../../context/ContextProvider";
import { useNavigate } from "react-router-dom";
import Loading from "../Loading/Loading";
import { enquiryOptions } from "../../options/EnquiryOptions";

const AsmLeadForm = ({
  developer,
  project,
  leadType = "Apartment",
  leadSource,
  language,
  enquiries = [],
}) => {
  const { BACKEND_URL, t, userInfo, ASM_URL } = useStateContext();

  const navigate = useNavigate();

  const optionsConfig = enquiryOptions(t);

  const [formData, setFormData] = useState({
    leadName: "",
    leadContact: "",
    leadEmail: "",
    country: userInfo?.state + ", " + userInfo?.countryName ?? "",
    developer: developer ?? "",
    project: project ?? "",
    projectName: project ?? "",
    enquiryType: "",
    leadType: leadType ?? "Apartment",
    language: language ?? "English",
    leadSource: leadSource ?? "Website",
    filename: "",
    ip: userInfo?.ip ?? "",
    device: userInfo?.userAgent ?? "",
    // notes: "",
  });

  const isOutsideUAE = userInfo?.countryName !== "United Arab Emirates";

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [countryCode, setCountryCode] = useState("");
  const [localNumber, setLocalNumber] = useState("");
  const [isValid, setIsValid] = useState(true);
  // const [time, setTime] = useState("");

  const contactFieldRef = useRef(null);
  const contactErrorRef = useRef(null);
  const submitBtnRef = useRef(null);
  // const timeInputRef = useRef(null);

  let clickId = null;

  // CHECK LAST SUBMISSION
  useEffect(() => {
    const checkLastSubmission = () => {
      const lastSubmission = localStorage.getItem("leadFormSubmission");
      if (lastSubmission) {
        const timeElapsed = Date.now() - parseInt(lastSubmission, 10);
        if (timeElapsed < 300000) {
          setShowForm(false);
          setLoading(false);
          return;
        }
      }
      setShowForm(true);
    };
    checkLastSubmission();
    setLoading(false);
  }, []);

  // URL PATH / FILENAME
  useEffect(() => {
    const path = window.location.pathname;
    const query = window.location.search;
    const fullPath = path + query;
    const fullUrl = window.location.href;
    setFormData((prevData) => ({
      ...prevData,
      filename: fullUrl,
      language: language
    }));
  }, []);

  // DEVICE 
  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      device: userInfo?.userAgent ?? "",
      language: language
    }));
  }, [userInfo]);

  // SOURCE OF LEAD
  useEffect(() => {
    // GET CURRENT URL
    const urlParams = new URLSearchParams(window.location.search.toLowerCase());
    const fullUrl = window.location.href.toLowerCase();
    let leadSource = localStorage.getItem("leadSource") || null; // Check stored source first
    let clickId = null;

    // Check if stored data is stale (e.g., older than 24 hours)
    const lastStored = localStorage.getItem("leadSourceTimestamp");
    if (lastStored && Date.now() - parseInt(lastStored) > 24 * 60 * 60 * 1000) {
      localStorage.removeItem("leadSource");
      localStorage.removeItem("originalReferrer");
      localStorage.removeItem("leadSourceTimestamp");
      leadSource = null;
    }

    // Store original referrer on first load
    if (!localStorage.getItem("originalReferrer")) {
      localStorage.setItem("originalReferrer", document.referrer || "");
    }

    // 1. Check click IDs (highest priority)
    if (urlParams.has("gclid")) {
      leadSource = "GoogleAds";
      clickId = urlParams.get("gclid");
    } else if (urlParams.has("ttclid")) {
      leadSource = "TikTok";
      clickId = urlParams.get("ttclid");
    } else if (urlParams.has("sccid")) {
      leadSource = "Snapchat";
      clickId = urlParams.get("sccid");
    } else if (urlParams.has("fbclid")) {
      leadSource = "Facebook";
      clickId = urlParams.get("fbclid");
    } else if (urlParams.has("twclid")) {
      leadSource = "X";
      clickId = urlParams.get("twclid");
    } else if (urlParams.has("utm_source")) {
      // 2. Check UTM parameters
      const utmSource = urlParams.get("utm_source").toLowerCase();
      const sourceMap = {
        google: "GoogleAds",
        facebook: "Facebook",
        fb: "Facebook",
        instagram: "Instagram",
        tiktok: "TikTok",
        snapchat: "Snapchat",
        twitter: "X",
        x: "X",
        linkedin: "LinkedIn",
      };
      leadSource = sourceMap[utmSource] || utmSource;
    } else {
      // 3. Check stored referrer or current referrer
      const referrer = localStorage.getItem("originalReferrer") || document.referrer.toLowerCase();
      if (referrer) {
        if (referrer.includes("google.com") || referrer.includes("googleadservices.com")) {
          leadSource = "GoogleAds";
        } else if (referrer.includes("facebook.com") || referrer.includes("fb.com")) {
          leadSource = "Facebook";
        } else if (referrer.includes("instagram.com")) {
          leadSource = "Instagram";
        } else if (referrer.includes("tiktok.com")) {
          leadSource = "TikTok";
        } else if (referrer.includes("snapchat.com")) {
          leadSource = "Snapchat";
        } else if (referrer.includes("twitter.com") || referrer.includes("x.com")) {
          leadSource = "X";
        } else if (referrer.includes("linkedin.com")) {
          leadSource = "LinkedIn";
        } else {
          leadSource = "Organic";
        }
      } else {
        // 4. Check user agent for in-app browsers
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.includes("instagram")) {
          leadSource = "Instagram";
        } else if (userAgent.includes("tiktok")) {
          leadSource = "TikTok";
        } else if (userAgent.includes("snapchat")) {
          leadSource = "Snapchat";
        } else if (userAgent.includes("twitter") || userAgent.includes("x.com")) {
          leadSource = "X";
        } else {
          leadSource = "Direct";
        }
      }
      // if (fullUrl.includes("tiktok")) {
      //   leadSource = "TikTok";
      // } else if (fullUrl.includes("facebook") || fullUrl.includes("fb")) {
      //   leadSource = "Facebook";
      // } else if (fullUrl.includes("instagram")) {
      //   leadSource = "Instagram";
      // } else if (fullUrl.includes("twitter")) {
      //   leadSource = "Twitter";
      // } else if (fullUrl.includes("linkedin")) {
      //   leadSource = "LinkedIn";
      // } else if (fullUrl.includes("snapchat")) {
      //   leadSource = "Snapchat";
      // } else if (fullUrl.includes("google")) {
      //   leadSource = "GoogleAds";
      // } else {
      //   leadSource = formData.leadSource;
      // }
    }

    // Only default to "Website" if no other source is identified
    if (!leadSource) {
      leadSource = "Website";
    } else {
      // Store leadSource in localStorage
      localStorage.setItem("leadSource", leadSource);
      localStorage.setItem("leadSourceTimestamp", Date.now().toString());
    }
    setFormData((prevData) => ({
      ...prevData,
      leadSource: leadSource,
      language: language
    }));
  }, []);

  // PHONE NUMBER
  useEffect(() => {
    const phoneField = contactFieldRef.current;
    const fetchIPData = async () => {
      try {
        // IP
        const response = await fetch("https://ipinfo.io/json");
        const data = await response.json();
        const userIp = data.ip || "";
        const countryCode = data.country || "ae";
        const state = data.region || "";

        // TEL INPUT
        const intlTelInputInstance = window.intlTelInput(
          contactFieldRef.current,
          {
            separateDialCode: true,
            initialCountry: "auto",
            geoIpLookup: (callback) => {
              callback(countryCode);
            },
            utilsScript:
              "//cdnjs.cloudflare.com/ajax/libs/intl-tel-input/24.3.3/js/utils.js",
          }
        );

        // Manually trigger an input event after initialization
        setTimeout(() => {
          const event = new Event("input", { bubbles: true });
          contactFieldRef.current.dispatchEvent(event);
        }, 200);

        // SET INITIAL FORM DATA
        setFormData((prevData) => ({
          ...prevData,
          country:
            state + ", " + intlTelInputInstance.getSelectedCountryData().name,
          ip: userIp,
          language: language
        }));

        // ON COUNTRY CHANGE
        phoneField.addEventListener("countrychange", () => {
          const countryData = intlTelInputInstance.getSelectedCountryData();
          setFormData((prevData) => ({
            ...prevData,
            country: state + ", " + countryData.name,
            ip: userIp,
            language: language
          }));
        });

        // INPUT VALIDATION
        // contactFieldRef.current
        phoneField.addEventListener("input", () => {
          const phoneNumber = intlTelInputInstance.getNumber();
          const countryCode =
            intlTelInputInstance.getSelectedCountryData().dialCode;
          setCountryCode(countryCode);
          if (intlTelInputInstance.isValidNumber()) {
            setIsValid(true);
            contactErrorRef.current.textContent = "";
            submitBtnRef.current.removeAttribute("disabled");
            const localPhoneNumber = phoneNumber.replace(`+${countryCode}`, "");
            setLocalNumber(localPhoneNumber);

            setFormData((prevData) => ({
              ...prevData,
              leadContact: phoneNumber,
              language: language
            }));
          } else {
            setIsValid(false);
            // contactErrorRef.current.textContent = t("validation_phone");
            contactErrorRef.current.textContent = "*";
            submitBtnRef.current.setAttribute("disabled", "true");
          }
        });

        // CLEAN UP ON UNMOUNT
        return () => {
          if (intlTelInputInstance) {
            intlTelInputInstance.destroy();
          }
        };
      } catch (error) {
        // console.error("Failed to fetch IP and country information", error);
      }
    };
    fetchIPData();
  }, [showForm]);

  // FORMAT TIME TO 12-HOUR WITH AM/PM
  // const formatTimeTo12Hour = (time24) => {
  //   if (!time24) return "";
  //   const [hours, minutes] = time24.split(":");
  //   let hoursNum = parseInt(hours, 10);
  //   const ampm = hoursNum >= 12 ? "PM" : "AM";
  //   hoursNum = hoursNum % 12 || 12; // Convert 0 or 12 to 12
  //   const formattedHours = hoursNum.toString().padStart(2, "0");
  //   return `${formattedHours}:${minutes} ${ampm}`;
  // };

  // HANDLE TIME CHANGE
  // const handleTimeChange = (e) => {
  //   const timeValue = e.target.value;
  //   setTime(timeValue);
  //   const formattedTime = formatTimeTo12Hour(timeValue); // e.g., "01:30 PM"
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     notes: formattedTime ? `${formattedTime}` : "",
  //   }));
  // };

  // HANDLE TIME INPUT CLICK
  // const handleTimeClick = () => {
  //   if (timeInputRef.current) {
  //     timeInputRef.current.showPicker();
  //   }
  // };

  // HANDLE CHANGE
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "leadContact") {
      setFormData((prevData) => ({
        ...prevData,
        leadContact: countryCode + value,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // VALIDATE FORM DATA
  const validate = () => {
    const newErrors = {};
    if (!formData.leadName) newErrors.leadName = t("validation_name");
    if (!formData.leadContact) newErrors.leadContact = t("validation_phone");
    if (!formData.enquiryType) newErrors.enquiryType = t("validation_enquiry");
    return newErrors;
  };

  // HANDLE FORM SUBMISSION

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   // console.log("Form submitted: ", formData);
  //   submitBtnRef.current.setAttribute("disabled", "true");

  //   // Validate form
  //   const newErrors = validate();
  //   if (Object.keys(newErrors).length > 0) {
  //     setErrors(newErrors);
  //     return;
  //   }
  //   setErrors(newErrors);
  //   setLoading(true);

  //   try {
  //     // BACKEND CALL
  //     const url = BACKEND_URL;
  //     console.log("URL: ", url);

  //     // AJAX CALL
  //     $.ajax({
  //       url: `${url}backend/controllers/ApoelezzAddLead.php`,
  //       method: "POST",
  //       contentType: "application/json",
  //       data: JSON.stringify(formData),
  //       dataType: "json",
  //       success: function (response) {
  //         console.log("Response from backend:", response);
  //         if (response.success) {
  //           console.log("Form submitted successfully.");
  //           localStorage.setItem("leadFormSubmission", Date.now().toString());
  //           setShowForm(false);
  //         } else {
  //           // console.error("Backend returned an error:", response.status);
  //         }

  //         if (response.thankyou) {
  //           if (language === "Arabic") {
  //             setLoading(false);
  //             // navigate("/thankyou/ar?lead-form-submit=true");
  //             window.location.href = "/thankyou/ar?lead-form-submit=true";
  //           } else {
  //             setLoading(false);
  //             // navigate("/thankyou?lead-form-submit=true");
  //             window.location.href = "/thankyou?lead-form-submit=true";
  //           }
  //         } else {
  //           if (response.blocked) {
  //             navigate("/blocked");
  //           } else {
  //             if (language === "Arabic") {
  //               setLoading(false);
  //               navigate("/thankyou/ar");
  //             } else {
  //               setLoading(false);
  //               navigate("/thankyou");
  //             }
  //           }
  //         }
  //       },
  //       error: function (jqXHR, textStatus, errorThrown) {
  //         // console.error("AJAX Error:", textStatus, errorThrown);
  //         console.log("Response Text:", jqXHR.responseText);
  //       },
  //     });
  //   } catch (error) {
  //     // console.error(error);
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    submitBtnRef.current.setAttribute("disabled", "true");

    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    setLoading(true);

    try {
      // CHECK FOR BLOCKED IP 
      const ip = formData.ip || userInfo?.ip || "";
      if (ip) {
        const checkBlockedResponse = await axios.get(
          `${ASM_URL}checkBlocked?ip=${encodeURIComponent(ip)}`
        );
        const checkBlockedData = checkBlockedResponse.data;

        // console.log("CheckBlocked response:", checkBlockedData);

        // Check if IP is blocked (status: true means blocked)
        if (checkBlockedData.status === true) {
          // console.log("IP is blocked");
          setLoading(false);
          submitBtnRef.current.removeAttribute("disabled");
          navigate("/blocked");
          return;
        }
      }
      const response = await axios.post(
        // `${url}backend/controllers/ApoelezzAddLead.php`,
        `${ASM_URL}create-lead`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const resData = response.data;

      if (resData.status) {
        // console.log("Form submitted successfully.");
        localStorage.setItem("leadFormSubmission", Date.now().toString());
        setShowForm(false);
        setLoading(false);
        if (language === "Arabic") {
          window.location.href = "/thankyou/ar?lead-form-submit=true";
        } else {
          window.location.href = "/thankyou?lead-form-submit=true";
        }
      } else {
        setLoading(false);
        if (language === "Arabic") {
          navigate("/thankyou/ar");
        } else {
          navigate("/thankyou");
        }
      }
    } catch (error) {
      console.error("Axios error:", error);
      if (error.response) {
        console.log("Response Text:", error.response.data);
      }
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loading />}
      <div className="mb-5 flex justify-center items-center">
        <div className="no-form-container" id="form-container">
          {showForm ? (
            <form
              id="lead-form"
              name="lead-form"
              // dir="ltr"
              onSubmit={handleSubmit}
            >
              <h4 className="text-center text-lg primary-text mb-8 font-bold">
                {language === "Arabic" ? (
                  <>سجل اهتمامك اليوم!</>
                ) : (
                  <>Register your interest today!</>
                )}
              </h4>
              {/* NAME */}
              <label htmlFor="leadName" className="mt-0">
                {t("name")}
              </label>
              <input
                type="text"
                name="leadName"
                id="leadName"
                value={formData.leadName}
                onChange={handleChange}
                required
                autoComplete="true"
              />
              {errors.leadName && (
                <small className="bg-red-600 text-white">{errors.leadName}</small>
              )}

              {/* CONTACT NUMBER */}
              <label htmlFor="leadContact">
                {t("contact")}
                <small
                  id="contactError"
                  ref={contactErrorRef}
                  className="text-red-600 text-lg rounded-full aspect-square"
                ></small>
              </label>
              <div dir="ltr">
                <input
                  type="tel"
                  ref={contactFieldRef}
                  name="leadContact"
                  id="leadContact"
                  placeholder="** *** ****"
                  value={localNumber}
                  onChange={handleChange}
                  required
                  autoComplete="true"
                />
              </div>

              {/* EMAIL */}
              {isOutsideUAE && (
                <>
                  <label htmlFor="leadEmail">{t("email")}</label>
                  <input
                    type="email"
                    name="leadEmail"
                    id="leadEmail"
                    value={formData.leadEmail}
                    onChange={handleChange}
                    required
                    autoComplete="true"
                  />
                </>
              )}

              {/* HOW MANY BEDROOMS */}
              <label>{t("bedrooms")}</label>
              {enquiries.map((key) => {
                const option = optionsConfig[key];
                return (
                  option && (
                    <div key={key} className="enquiry-radio flex">
                      <input
                        className="mx-2"
                        type="radio"
                        name="enquiryType"
                        id={`EnquiryRadio${key}`}
                        value={option.value}
                        required
                        onChange={handleChange}
                      />
                      <label htmlFor={`EnquiryRadio${key}`} className="m-0">
                        <div className="px-2">{option.label}</div>
                        <div className="flex items-center px-2">
                          {option.icon}
                        </div>
                      </label>
                    </div>
                  )
                );
              })}
              {errors.enquiryType && (
                <small className="bg-red-600 text-white">
                  {errors.enquiryType}
                </small>
              )}

              {/* PREFERRED CONTACT TIME */}
              {/* <label htmlFor="time">{t("preferred_time")}</label>
              <input
                type="time"
                name="time"
                id="time"
                ref={timeInputRef}
                value={time}
                onChange={handleTimeChange}
                onClick={handleTimeClick}
                placeholder="01:30 PM"
                className="w-full"
                required
              /> */}

              <div className="mt-5">
                <button
                  type="submit"
                  className="submit-btn"
                  id="submit-btn"
                  ref={submitBtnRef}
                  disabled={false}
                >
                  {t("submit")}
                </button>
              </div>
            </form>
          ) : (
            <div className="p-6 text-center my-5">
              {/* {t("thankyou")} */}
              <span className="text-white">
                {language === "Arabic"
                  ? "شكرا لتواصلك معنا."
                  : "Thank you for reaching out to us."}
                &nbsp;
              </span>
              <br />
              {language === "Arabic"
                ? "سيتواصل معك مستشارنا المخصص قريبًا لتلبية احتياجاتك."
                : "Our dedicated consultant will be in contact with you shortly to address your needs."}
              &nbsp;
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default AsmLeadForm;
